import { FC, useMemo } from "react"
import { RateFlowDetails } from "../../../types"
import Select from "../form/select"

interface Props {
  rateflows: RateFlowDetails[]
  selectedId: string
  onChange: (id: string) => void
}

const RateflowSelector: FC<Props> = ({ rateflows, selectedId, onChange }) => {
  // Check if we have rateflows from multiple brands
  const hasMultipleBrands = useMemo(() => {
    const brandIds = new Set(rateflows.map(rf => rf.bank_id))
    return brandIds.size > 1
  }, [rateflows])

  const options = useMemo(
    () =>
      rateflows.map(rf => {
        let label = rf.name
        if (rf.default === "1") label += " (Default)"
        if (hasMultipleBrands) label += ` [${rf.bank_id}]`
        return { id: rf.id, name: label }
      }),
    [rateflows, hasMultipleBrands]
  )

  return (
    <div className="w-72">
      <Select
        label="Select Rateflow"
        name="rateflow"
        data={options}
        selected={selectedId}
        setSelected={onChange}
      />
    </div>
  )
}

export default RateflowSelector
